import React, { useRef, useState } from 'react';
import { IconButton } from '@ff-os/shared-react/components/buttons/icon-button/IconButton';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { Tooltip } from '@ff-os/shared-react/components/tooltip/Tooltip';
import { useClickOutside } from '@ff-os/shared-react/hooks/useClickOutside';
import { useMobile } from '@ff-os/shared-react/hooks/useMobile';
import { MouseControls3dTooltip } from './MouseControls3dTooltip';
import { TouchControls3dTooltip } from './TouchControls3dTooltip';
import styles from './Controls3dTooltip.module.scss';

export const Controls3dTooltip = () => {

    const isMobile = useMobile();

    const [showControls, setShowControls] = useState(false);
    const ref = useRef<HTMLDivElement>(null);
    useClickOutside(ref.current, () => setShowControls(false));

    return (
        <div className={styles.default} ref={ref}>
            {isMobile ? (
                <Tooltip active={showControls} align='start' position='bottom'>
                    <TouchControls3dTooltip />
                </Tooltip>
            ) : (
                <Tooltip active={showControls} align='start' position='right'>
                    <MouseControls3dTooltip />
                </Tooltip>
            )}

            <IconButton small
                className={styles.button}
                onClick={() => setShowControls(!showControls)}>
                <Icon type='alert-circle-help' />
            </IconButton>
        </div>
    );
};